// extracted by mini-css-extract-plugin
export default {"container":"User_container__rrMpN","header":"User_header__Sei83","info1":"User_info1__n04Xy","label":"User_label__O-hUq","divButton":"User_divButton__MpANQ"};